import $ from 'jquery';

export default () => {

  const stateSelector = $('[data-thelia-state]');
  const stateWrapper = $(stateSelector.data('thelia-toggle'))
  const countrySelector = $('[data-thelia-country]');
  const currentState = $(stateSelector).val();

  const emptyState = stateSelector.find('option[value=""]').detach();
  const states = stateSelector.find('option').detach();

  countrySelector.on('change', function() {
    const country = $(this).val();
    const countryStates = states.filter(`option[data-country="${country}"]`);
    
    if (countryStates.length > 0) {
      stateWrapper.show();
      stateSelector.empty().append(emptyState).append(countryStates);
      stateSelector.val('').change();
    } else {
      stateWrapper.hide();
    }
    
  });
  countrySelector.change();
  stateSelector.val(currentState);
}



// WEBPACK FOOTER //
// ./assets/src/js/modules/stateFilter.js